import { color } from '@upstox/upstox-ui';

export const dropdownButton: CSSFunction = ({ theme }) => ({
   borderRadius: '0px',
   border: `1px solid ${color(theme, theme.colors.ui3)}`,
   height: '28px',
   justifyContent: 'space-between',
   padding: '8px 3px 8px 16px',
   width: '170px',
});

export const dropdownMenu: CSSFunction = ({ theme }) => ({
    maxHeight: '150px',
    textTransform: 'uppercase',
    overflowY: 'auto',
    overflowX: 'hidden',
    width: '100%',
    '::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      width: 6,
      height: 6,
    },
    '::-webkit-scrollbar-thumb': {
      borderRadius: '4px',
      backgroundColor: color(theme, 'ui8'),
    },
 });

export const dropdownOption: CSSFunction = () => ({
   margin: '6px 0px',
});
